import { Tabs } from "@base-ui-components/react/tabs";
import { classed } from "@frend-digital/ui";
import styles from "./Tabs.module.css";

export const TabsRoot = classed(Tabs.Root, styles.Tabs);

export const TabsList = classed(Tabs.List, styles.List);

export const TabsTab = classed(Tabs.Tab, styles.Tab);

export const TabsIndicator = classed(Tabs.Indicator, styles.Indicator);
export const TabsPanel = classed(Tabs.Panel, styles.Panel);
